import React from "react";
import {
  FaWallet,
  FaShieldAlt,
  FaChartLine,
  FaGavel,
  FaCoins,
} from "react-icons/fa";

function ServiceCard({ Icon, title, description }) {
  return (
    <div className="col-lg-4 col-md-6 process-two-single pt-4">
      <div className="services-style-two-item fade-up-anim">
        <div className="top-info">
          <Icon size={40} />
          <h4 className="pt-3">{title}</h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

function MultiAssetPortfolio() {
  const services = [
    {
      title: "Multi-Asset Portfolio Management",
      description:
        "Manage diverse portfolios of cryptocurrencies and digital assets across multiple wallets and exchanges, all in one unified dashboard.",
      Icon: FaWallet,
    },
    {
      title: "Institutional-Grade Security",
      description:
        "Implement advanced security protocols including multi-signature wallets, hardware wallets, and two-factor authentication to safeguard your assets.",
      Icon: FaShieldAlt,
    },
    {
      title: "Automated Reporting and Analytics",
      description:
        "Gain insights with automated performance tracking, real-time analytics, and custom reporting to make informed investment decisions.",
      Icon: FaChartLine,
    },
    {
      title: "Risk Management and Compliance",
      description:
        "Navigate regulatory complexities with our tailored compliance tools that ensure adherence to AML, KYC, and other financial regulations.",
      Icon: FaGavel,
    },
    {
      title: "DeFi and Staking Management",
      description:
        "Maximize returns with staking, yield farming, and liquidity provision services for DeFi assets, integrated directly into your management dashboard.",
      Icon: FaCoins,
    },
  ];

  return (
    <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What we do</h4>
              <h2 className="title split-text-right split-text-in-right">
                Our Crypto Asset Management Services
              </h2>
            </div>
          </div>
        </div>
        <div className="container fade-up-anim">
          <div className="row justify-content-center">
            {services.map((service, index) => (
              <ServiceCard key={index} {...service} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultiAssetPortfolio;
